export default [
  {
    type: 'STRING',
    name: 'name',
    defaultName: 'Name',
  },
  {
    type: 'STRING',
    name: 'description',
    defaultName: 'Description',
  },
  {
    type: 'STRING',
    name: 'profileImage',
    defaultName: 'Profile Image',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'contentHouseId',
    defaultName: 'Content House Id',
  },
]
